import { Permission } from '../_models/permission.model';
import { ModuleType } from '../enums/module.enum';
import { PermissionType } from '../enums/permission.enum';


export interface IPermissionCollecton {
  modules: IPermissionCollectonModule[];
}

export interface IPermissionCollectonModule {
  moduleId: number;
  pagePermissions: Permission[];
  rowPermissions: Permission[];
}

export const permissions: IPermissionCollecton = {
  modules: [
    {
      moduleId: ModuleType.Role,
      pagePermissions: [
        new Permission().deserialize({ id: PermissionType.RoleAdd, name: 'add', icon: 'add' })
      ],
      rowPermissions: [
        new Permission().deserialize({ id: PermissionType.RoleEdit, name: 'edit', icon: 'edit' }),
        new Permission().deserialize({ id: PermissionType.RoleDelete, name: 'delete', icon: 'delete' })
      ]
    },
    {
      moduleId: ModuleType.User,
      pagePermissions: [
        new Permission().deserialize({ id: PermissionType.UserAdd, name: 'add', icon: 'add' })
      ],
      rowPermissions: [
        new Permission().deserialize({ id: PermissionType.UserEdit, name: 'edit', icon: 'edit' }),
        new Permission().deserialize({ id: PermissionType.UserDelete, name: 'delete', icon: 'delete' })
      ]
    },
    {
      moduleId: ModuleType.Audits,
      pagePermissions: [],
      rowPermissions: [
        new Permission().deserialize({ id: PermissionType.AuditoryDetail, name: 'view', icon: 'remove_red_eye' })
      ]
    }
  ]
};
